import { isItemReviewable } from '@/lib/utils/auditStages';
import { useAgenticStore } from '@/store/agenticStore';
import { useAiProcessingData } from './useAiProcessingData';

/**
 * Logic for the navbar AI-processing button + hover popover: the queue stats
 * (ring / "to review" badge) and the in-progress / ready item lists for the
 * popover. Clicking opens the agentic panel straight onto the Processing tab.
 */
export function useAiProcessingWidget() {
  const { stats, items } = useAiProcessingData();
  const openProcessing = useAgenticStore(s => s.openProcessing);

  const inProgressItems = items.filter(item => item.status === 'PROCESSING');
  // "Ready to review" = jobs with a finished, not-yet-reviewed reviewable stage
  // (isItemReviewable), NOT every COMPLETED job. `stats.completed` counts all
  // finished jobs (including already-reviewed ones), so counting off it
  // over-counts the badge — mirror the queue's Ready-to-review section instead.
  const readyItems = items.filter(isItemReviewable);

  return {
    stats,
    inProgressItems,
    readyItems,
    openProcessing,
  };
}
